import { Money } from "classes/DecimalClasses";

import { formatMoneyWithAdornments } from "services/utility/formatting";

export function getOtherCostsTotal(data, column, record) {
  const { otherCosts, currency } = record;
  const otherCostTotal = otherCosts.reduce(
    (seed, { amount }) => (amount ? seed.plus(amount) : seed),
    Money.ZERO(currency?.name)
  );
  return formatMoneyWithAdornments(otherCostTotal);
}

export function getItemReceiptTotalWithAdornments(data, column, record) {
  const { otherCosts, currency } = record;
  const linesTotal = data.reduce(
    (seed, row) => (row[column] ? seed.plus(row[column]) : seed),
    Money.ZERO(currency?.name)
  );
  const otherCostTotal = otherCosts.reduce(
    (seed, { amount }) => (amount ? seed.plus(amount) : seed),
    Money.ZERO(currency?.name)
  );
  return formatMoneyWithAdornments(linesTotal.plus(otherCostTotal));
}

export function formatOtherCostAmount(value, record) {
  return formatMoneyWithAdornments(new Money(value, record.currency?.name));
}
